__turbopack_context__.v({
  "circle": "STLoader-module__Y_UQZW__circle",
  "loader": "STLoader-module__Y_UQZW__loader",
  "loaderWrapper": "STLoader-module__Y_UQZW__loaderWrapper",
  "spin988": "STLoader-module__Y_UQZW__spin988",
});
